import MsgComponent from './msg.vue';

const Msg = {};

Msg.install= (Vue) => {//install是vue官方提供的开发插件的key值
    const vue = Vue;//遵循eslint不直接修改参数的规范
    const MsgClass= vue.extend(MsgComponent);//将组件变成一个类
    // 
    const instance = new MsgClass();//然后实例化
    // 
    instance.$mount(document.createElement('div'));//把这个实例化后的对象挂载到一个新建的div上
    document.body.appendChild(instance.$el);//在body中添加这个div,instance.$el即上面的div
    // 

    let timer;

    const MsgMain = {
        show_message(txt,type){
            clearTimeout(timer);
            timer = setTimeout(()=>{
                instance.visible = false;
                // 
            },2000);
            instance.txt = txt;//将各种参数注入到实例对象里面
            // 
            instance.type = type;
            // 
            // 
            instance.visible = true;
            // 
        },
        success(txt,type='success'){
            // 
            this.show_message(txt,type);
            
        },
        fail(txt,type='fail'){
            this.show_message(txt,type);
        },
    };
    vue.prototype.$message = MsgMain;//将自定义的方法加入vue的原型链中，供所有实例继承
};
export default Msg;


// WEBPACK FOOTER //
// ./src/components/common/msg.js